<template>
  <thead class="table__header">
    <tr>
      <th
        v-if="checkbox || dropdownMenu.length"
        :class="[
          { 'table__header__th--checkbox': checkbox && !dropdownMenu.length },
          { 'table__header__th--dropdown': !checkbox && dropdownMenu.length },
          { 'table__header__th--actions': checkbox && dropdownMenu.length },
        ]"
      >
        <v-checkbox
          v-if="checkbox"
          v-model="selectedAllLines"
          :disabled="!selectedCompany"
          color="primary"
          on-icon="check_box"
          off-icon="check_box_outline_blank"
          hide-details
        />
      </th>

      <th
        v-for="(header, index) in headers"
        :key="`${header}-${index}`"
        :class="[
          header.class,
          { 'table__header__th--sortable': header.sortable }
        ]"
      >
        {{ header.text }}
      </th>
    </tr>
  </thead>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'THead',
  props: {
    headers: {
      type: Array,
      require: true
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    dropdownMenu: {
      type: Array,
      default: () => []
    },
    selectedAllLinesCheckbox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      selectedAllLines: false
    }
  },
  watch: {
    selectedAllLines (boolean) {
      this.$emit('selectedAllLines', boolean)
    },

    selectedAllLinesCheckbox (boolean) {
      this.selectedAllLines = boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.table__header {
  background-color: $gray-2;

  tr {
    border-bottom: 1px solid $gray-4;
    height: 50px;
  }

  th {
    color: $gray-8;
    font-size: $base-font-size - 1px;
    font-weight: 600;
    padding: 8px 16px;
    text-align: left;
    white-space: nowrap;

    > .v-input {
      margin: 0;
      padding: 0;
    }

    &.table__header__th--sortable {
      color: $gray-8;
    }

    &.table__header__th--checkbox {
      padding-right: 8px;
    }

    &.table__header__th--checkbox,
    &.table__header__th--dropdown {
      max-width: 56px;
      min-width: 56px;
      width: 56px;
    }

    &.table__header__th--actions {
      max-width: 100px;
      min-width: 100px;
      padding-right: 8px;
      width: 100px;
    }
  }
}
</style>
